<template>
  <div class="row-box">
    <WrapperField
      v-for="(value, index) in data"
      :key="value + index"
      :data="
        createDataField({
          fieldName: index,
          fieldValue: value,
          fieldGroup: FieldGroup.STORAGE_ACCEPT_DETAILS,
        })
      "
    ></WrapperField>
  </div>
</template>

<script>
import { createDataField } from '@/utils/fullStatementView';
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';
import { FieldGroup } from '@/utils/fullStatementView';

export default {
  name: 'Step2',
  components: { WrapperField },
  props: ['data'],
  created() {
    delete this.data.note;
    delete this.data.hasPrivilege;
  },
  data: () => ({
    createDataField,
    FieldGroup,
  }),
  methods: {},
};
</script>
